module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/stepsConfetti-7127480e906ec6a0350d6cb93394aed3.png";